// MyComponent.jsx
import React from 'react';
import Title from '../Title';

const KeyDifferent = () => {
  return (
    <div className='main_img'>
        <div className='container'>
        <div className='section_main_title d-flex align-items-center justify-content-between'>
            <Title text="KEY DIFFERENTIATORS" className="custom-heading" />
            <ul className='d-flex align-items-center'>
            <li className='green'>personalized service </li>
            <li className='orange'>timely delivery</li>
            <li className='light-blue'>optimized performance</li>
            </ul>
        </div>
        <div className='key_main_wrapper row mb-5'>
            <div className='col-md-6 col-lg-6'>
                <div className='inr_content_wrap d-flex align-items-center'>
                    <img src='/images/01.jpg' alt='differentiators'></img>
                    <div className='column'>
                        <h3>Comprehensive Expertise</h3>
                        <p>Our team comprises seasoned professionals with diverse expertise in various
                            fields such as accounting, taxation, audit, and financial advisory,
                            ensuring all your financial needs are met under one roof.</p>
                    </div>
                </div>
            </div>
            <div className='col-md-6 col-lg-6 d-flex'>
                <div className='inr_content_wrap d-flex align-items-center'>
                <img src='/images/02.jpg' alt='differentiators'></img>
                    <div className='column'>
                        <h3>Personalized Client Service</h3>
                        <p>We prioritize building strong relationships with our clients, offering personalized and responsive service tailored to meet the unique needs of each business, ensuring effective and customized solutions.</p>
                    </div>
                </div>
            </div>
            <div className='col-md-6 col-lg-6 d-flex'>
                <div className='inr_content_wrap d-flex align-items-center'>
                <img src='/images/03.jpg' alt='differentiators'></img>
                    <div className='column'>
                        <h3>Ethical Practices & Integrity
                        </h3>
                        <p>We uphold the highest standards of integrity and ethics in all our operations, ensuring transparency, compliance, and trustworthiness in every service we provide.</p>
                    </div>
                </div>
            </div>
            <div className='col-md-6 col-lg-6 d-flex'>
                <div className='inr_content_wrap d-flex align-items-center'>
                <img src='/images/04.jpg' alt='differentiators'></img>
                    <div className='column'>
                        <h3>Cutting-Edge Technology Integration</h3>
                        <p>We leverage the latest technology to enhance efficiency and accuracy in our services, providing innovative solutions that drive business growth and operational excellence.</p>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
  );
};

export default KeyDifferent;